export interface IAppSettings {
    buildMode: "Development" | "Test" | "Staging" | "Training" | "Production";
    reportServerUrl: string;
    reportFolder: string;
    googleAnalyticsId: string;
    group2Enabled: boolean;
}

export const AppSettings: IAppSettings = (window as any).env; // || { buildMode: "Development", reportServerUrl: "", reportFolder: "", googleAnalyticsId: ""}; 